import { request } from './client';

export const apiGetAllCoupons = () => request('/coupons');

export const apiCreateCoupon = (data) =>
  request('/coupons', { method: 'POST', body: data });

export const apiUpdateCoupon = (id, data) =>
  request(`/coupons/${id}`, { method: 'PUT', body: data });

export const apiDeleteCoupon = (id) =>
  request(`/coupons/${id}`, { method: 'DELETE' });
